'use strict';

class ExpertiseNav {

    constructor() {

        let list = document.querySelector('.expertise__nav-list');

        if (!list) {

            return;

        }

        let active = list.querySelector('.expertise__nav-item.active');

        if (!active) {

            return;

        }

        let listRect = list.getBoundingClientRect();
        let activeRect = active.getBoundingClientRect();

        let offset = (activeRect.left + activeRect.width / 2) - (listRect.left + listRect.width / 2);

        list.scrollLeft += offset;

    }

}

module.exports = ExpertiseNav;
